export const REMINDER_DELAY_DAYS = 3;

export type UserAccessReminderStage = 'not_started' | 'in_progress';

export interface ReminderScheduleInput {
  dueAt: string;
  sentAt: string | null;
  lastReminderAt: string | null;
  delegatedAt: string | null;
  nextReminderAt: string | null;
  startedAt: string | null;
  reminderCount: number;
}

export function reminderStage(startedAt: string | null): UserAccessReminderStage {
  return startedAt ? 'in_progress' : 'not_started';
}

export function firstReminderAt(now: Date): Date {
  return addReminderDays(now, REMINDER_DELAY_DAYS);
}

export function reminderDelayDaysAfterSend(
  reminderCountAfterSend: number,
  startedAt: string | null,
  dueAt: string,
  now = new Date()
): number {
  void reminderCountAfterSend;
  void startedAt;
  void dueAt;
  void now;
  return REMINDER_DELAY_DAYS;
}

export function effectiveNextReminderAt(
  schedule: ReminderScheduleInput,
  _now = new Date()
): Date | null {
  const configuredTime = parseTimestamp(schedule.nextReminderAt);
  if (configuredTime === null) return null;
  const anchorTime = latestTimestamp([
    schedule.sentAt,
    schedule.lastReminderAt,
    schedule.delegatedAt,
  ]);
  if (anchorTime === null) return new Date(configuredTime);

  const cadenceTime = addReminderDays(
    new Date(anchorTime),
    REMINDER_DELAY_DAYS
  ).getTime();
  return new Date(Math.min(configuredTime, cadenceTime));
}

export function addReminderDays(date: Date, days: number): Date {
  const next = new Date(date);
  next.setUTCDate(next.getUTCDate() + days);
  return next;
}

function latestTimestamp(values: Array<string | null>): number | null {
  const parsed = values
    .map(parseTimestamp)
    .filter((value): value is number => value !== null);
  return parsed.length > 0 ? Math.max(...parsed) : null;
}

function parseTimestamp(value: string | null): number | null {
  if (!value) return null;
  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : null;
}
